import React, { useState, useEffect, useContext } from "react";
import { ProjectContext } from "../App.js";
import { Link } from "react-router-dom";
import { useRolePermissions } from "../components/Settings/RoleContext.js";
import { FaChevronDown } from "react-icons/fa";
import api from "../api/axiosConfig.js";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import ".././styles/projects/Projects.css";
import { useAuth } from "./Authentication/AuthContext";
import { Helmet } from "react-helmet";
import { ToastContainer, toast } from "react-toastify";

const GroupList = () => {
  const { isNavBarOpen } = useContext(ProjectContext);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [users, setUsers] = useState([]);
  const { userDetails } = useAuth();
  const { hasPermission } = useRolePermissions();
  const userRole = userDetails.role;
  const [refreshTrigger, setRefreshTrigger] = useState(false);
  const [activeGroupLink, setGroupActiveLink] = useState(() => {
    return localStorage.getItem("activegroups") || "overallgroup";
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [newUserName, setNewUserName] = useState("");
  const [newGroup, setNewGroup] = useState({
    name: "",
    code: "",
    description: "",
    manager: "",
  });
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedGroupIdToDelete, setSelectedGroupIdtoDelete] = useState([]);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

  const handleGroupLinkClick = (link) => {
    setGroupActiveLink(link); // Update the active link
    localStorage.setItem("activegroups", link);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const endpoint =
          userDetails.role_name === "Administrator" ||
          userDetails.role_name === "Super Admin"
            ? `/api/groups`
            : `/api/groups/${userDetails.id}`;
        const adminRes = await api.get(`/api/users`);
        const activeUsers = adminRes.data.filter(
          (member) => member.status !== "Inactive"
        );
        setUsers(activeUsers);
        const res = await api.get(endpoint);
        setGroups(res.data);
      } catch (error) {
        setError(error);
        console.error("Error fetching groups:", error.message || error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [userRole, userDetails.id]);

  // Handle closing the dialog
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setNewUserName(""); // Reset input field
  };
  const onHandleAddGroup = () => {
    setOpenAddDialog(true);
    document.body.classList.add("no-scroll");
  };
  // Handle adding a user
  const handleAddUser = async () => {
    try {
      await api.post(`/api/groups/${selectedGroupId}/add-user`, {
        name: newUserName,
      });
      // Optionally refresh the group data or show success message
      handleCloseDialog();
    } catch (error) {
      console.error("Error adding user:", error.message || error);
    }
  };

  //add new group
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewGroup((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddNewgroup = async () => {
    try {
      const response = await api.post("/api/newgroup", newGroup);
      if (response.status === 201) {
        const addedGroup = response.data;
        setGroups((prevGroups) => [...prevGroups, addedGroup]);
        setRefreshTrigger(!refreshTrigger);
        setNewGroup({
          name: "",
          code: "",
          description: "",
          manager: "",
        });
        setOpenAddDialog(false);
      } else {
        toast.error("Failed to add group. Please try again.", {
          position: "bottom-center",
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error("Error adding group:", error); // Log the error
      toast.error(
        `Failed to add group: ${error.response?.data || error.message}`,
        {
          position: "bottom-center",
          autoClose: 2000,
        }
      );
    }
  };
  const handleDeleteGroup = (e, groupId) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      setSelectedGroupIdtoDelete((prev) => [...prev, groupId.id]); // Add customer ID to the list
    } else {
      setSelectedGroupIdtoDelete(
        (prev) => prev.filter((id) => id !== groupId.id) // Use the ID directly for filtering
      );
    }
  };
  const handleCloseDial = () => {
    setIsCheckboxChecked(false);
    setDeleteDialogOpen(false);
    // setSelectedCustomerIdtoDelete("");
    document.body.classList.remove("no-scroll");
  };
  const handleDeleteGroups = async () => {
    const groupIds = selectedGroupIdToDelete; // Get the array of selected group IDs
    setIsCheckboxChecked(false);
    setDeleteDialogOpen(false);

    try {
      const response = await api.delete("/api/deletegroup", {
        data: { Ids: groupIds }, // Ensure "Ids" matches the parameter expected by the backend
      });

      setGroups((prevGroups) =>
        prevGroups.filter((group) => !groupIds.includes(group.id))
      );
      // Refresh data or update state accordingly
      setRefreshTrigger(!refreshTrigger); // Trigger a re-fetch or update the UI
      setSelectedGroupIdtoDelete([]); // Reset the selected IDs after deletion
    } catch (error) {
      console.error("Error deleting groups:", error.message || error); // Log any error
    }
  };

  if (loading)
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <span className="loading-animation">LOADING...</span>
      </div>
    );
  if (error) return <p>Error loading groups</p>;

  return (
    <div className="group-main-container">
      <ToastContainer />
      <Helmet>
        <title>Msuite - Projects</title>
      </Helmet>
      <div
        className="project-nav-bar-details"
        style={{ top: "0px", left: "-92px", position: "relative" }}
      >
        {/* <h3>Groups</h3> */}
        <div className="project-tab-details">
          <Link
            className={`proj-links ${
              activeGroupLink === "activegroup" ? "active" : ""
            }`}
            onClick={() => handleGroupLinkClick("activegroup")}
          >
            Active Group
          </Link>
          <Link
            className={`proj-links ${
              activeGroupLink === "overallgroup" ? "active" : ""
            }`}
            onClick={() => handleGroupLinkClick("overallgroup")}
          >
            Overall Group
          </Link>
        </div>
        <hr className="proj-line" />
      </div>
      {hasPermission("groups", "delete") &&
        selectedGroupIdToDelete.length > 0 && (
          <button
            className="delete-group"
            onClick={() => setDeleteDialogOpen(true)}
            title="Delete Customer"
            style={{ left: "91.8" }}
          >
            Delete
          </button>
        )}
      {hasPermission("groups", "create") && (
        <button
          className="add-group-heading"
          onClick={onHandleAddGroup}
          title="New Group"
        >
          New Group
        </button>
      )}
      <div
        className={
          isNavBarOpen
            ? "group-project-container"
            : "group-project-container-close"
        }
      >
        <table
          className={
            isNavBarOpen ? "group-content-table" : "group-content-table-close"
          }
        >
          <thead>
            <tr>
              <th style={{ width: "2px" }}>
                <FaChevronDown />
              </th>
              <th style={{ width: "100px" }}>Group Code</th>
              <th style={{ width: "200px" }}>Group Name</th>
              <th style={{ width: "200px" }}>Group Manager</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {groups.map((group, index) => (
              <tr key={group.id}>
                <td style={{ textAlign: "center" }}>
                  {" "}
                  <input
                    style={{ cursor: "pointer" }}
                    type="checkbox"
                    name={group.id}
                    checked={selectedGroupIdToDelete.includes(group.id)}
                    onChange={(e) => handleDeleteGroup(e, group)}
                  />
                </td>
                <td>
                  {hasPermission("groups", "update") ? (
                    <Link to={`/group/${group.id}`} className="group-name">
                      {group.code}
                    </Link>
                  ) : (
                    <span>{group.code}</span>
                  )}
                </td>
                <td>{group.name}</td>
                <td>{group.manager_user_name}</td>
                <td></td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Add User Dialog */}
        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogTitle>Add New User to Group</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="User Name"
              type="text"
              fullWidth
              value={newUserName}
              onChange={(e) => setNewUserName(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>Cancel</Button>
            <Button onClick={handleAddUser} color="primary">
              Add User
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      {openAddDialog && (
        <div className="add-group-d-dial">
          <div className="add-project-content">
            <div
              className="add-group-user-header"
              style={{ marginLeft: "0px" }}
            >
              <h3
                className="add-project-user-heading"
                style={{ marginLeft: "8px", fontWeight: "550px" }}
              >
                Add New Group
              </h3>
            </div>
            <div className="customer-form">
              <label className="customer-label">Group Name:</label>
              <input
                type="text"
                name="name"
                className="customer-input"
                placeholder="Enter Group name"
                value={newGroup.name}
                onChange={handleInputChange}
                maxLength={30}
              />

              <label className="customer-label">Group Code:</label>
              <input
                type="text"
                name="code"
                placeholder="Enter Group Code"
                className="customer-input"
                value={newGroup.code}
                onChange={handleInputChange}
                maxLength={20}
              />

              <label className="customer-label">Description:</label>
              <input
                type="text"
                name="description"
                placeholder="Enter Description"
                className="customer-input"
                value={newGroup.description}
                onChange={handleInputChange}
                maxLength={100}
              />

              <label className="customer-label">Manager:</label>
              <select
                name="manager"
                className="customer-input-dropdown"
                value={newGroup.manager}
                onChange={handleInputChange}
              >
                <option value="" disabled>
                  Select Manager
                </option>
                {users
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.name}
                    </option>
                  ))}
              </select>
              <br />
            </div>
            <div className="group-btn-container">
              <button
                style={{ marginLeft: "24px" }}
                className="add-btn"
                onClick={handleAddNewgroup}
              >
                Add
              </button>
              <button
                className="cancel-btn"
                onClick={() => {
                  setOpenAddDialog(false);
                  setNewGroup({
                    name: "",
                    code: "",
                    description: "",
                    manager: "",
                  });
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {deleteDialogOpen && (
        <div className="delete-phase-dial" style={{ marginTop: "-8px" }}>
          <div className="delete-dial">
            <div className="delete-header">
              <h3
                style={{
                  backgroundColor: "transparent",
                  marginLeft: "13px",
                  fontSize: "15px",
                }}
              >
                Delete Customer
              </h3>
            </div>
            <div style={{ backgroundColor: "white" }}>
              <p style={{ backgroundColor: "white" }}>
                Are you sure you want to delete this Group? This action cannot
                be undone.
              </p>
              <input
                style={{ cursor: "pointer" }}
                type="checkbox"
                id="delete-phase"
                checked={isCheckboxChecked}
                onChange={() => setIsCheckboxChecked((prev) => !prev)}
              />
              <label
                htmlFor="delete-phase"
                style={{ backgroundColor: "white", cursor: "pointer" }}
              >
                I understand this action cannot be undone.
              </label>
            </div>
            <div className="delete-dial-btn-con">
              <button
                onClick={handleDeleteGroups}
                color="secondary"
                variant="contained"
                disabled={!isCheckboxChecked}
                className="add-btn"
                style={{ backgroundColor: isCheckboxChecked ? "red" : "gray" }}
              >
                Delete
              </button>

              <button onClick={handleCloseDial} className="cancel-btn">
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GroupList;
